import MessageComposer from "../conversations/message-composer"

const CustomOutOfMessage = ({ userinput, handleMessageChanges, AfterHoursClick, IsAfterHoursActive }) => {

    return (
        <div className={`w-p-100 d-flex flex-direction ${IsAfterHoursActive ? "bg-color-settings-background" : ""}`}>
            <div className="br-5">
                <div className="bg-color-danger-font br-5">
                    <MessageComposer
                        Limit={1}
                        IsAfterHoursActive={IsAfterHoursActive}
                        IsCamPaign={false}
                        IsNewMessage={false}
                        IsAddTemplate={true}
                        IsAfterHours={true}
                        Message={userinput?.Message}
                        HandleChange={handleMessageChanges}
                        AfterHoursClick={AfterHoursClick}
                    />
                </div>
            </div>
        </div>
    )
}

export default CustomOutOfMessage